/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  Comune,
  ComuniResponse,
  Provincia,
  StatiEsteriResponse,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco degli stati esteri
 * @summary Elenco degli stati esteri
 */
export const getGeolocalizzazioneStatiEsteri = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<StatiEsteriResponse>(
    {
      url: `/framework-cfg-domande/geolocalizzazione/stati-esteri`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneStatiEsteriQueryKey = () =>
  [`/framework-cfg-domande/geolocalizzazione/stati-esteri`] as const;

export const getGetGeolocalizzazioneStatiEsteriQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeolocalizzazioneStatiEsteriQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>
  > = ({ signal }) => getGeolocalizzazioneStatiEsteri(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetGeolocalizzazioneStatiEsteriQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>
>;
export type GetGeolocalizzazioneStatiEsteriQueryError = ErrorType<unknown>;

/**
 * @summary Elenco degli stati esteri
 */
export const useGetGeolocalizzazioneStatiEsteri = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeolocalizzazioneStatiEsteriQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene la provincia ricercata tramite codice
 * @summary Dettaglio della provincia dal codice
 */
export const getGeolocalizzazioneProvinceCodice = (
  codice: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Provincia>(
    {
      url: `/framework-cfg-domande/geolocalizzazione/province/${codice}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneProvinceCodiceQueryKey = (codice: string) =>
  [`/framework-cfg-domande/geolocalizzazione/province/${codice}`] as const;

export const getGetGeolocalizzazioneProvinceCodiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneProvinceCodice>>,
  TError = ErrorType<unknown>,
>(
  codice: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneProvinceCodice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazioneProvinceCodice>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetGeolocalizzazioneProvinceCodiceQueryKey(codice);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazioneProvinceCodice>>
  > = ({ signal }) =>
    getGeolocalizzazioneProvinceCodice(codice, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!codice, ...queryOptions };
};

export type GetGeolocalizzazioneProvinceCodiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazioneProvinceCodice>>
>;
export type GetGeolocalizzazioneProvinceCodiceQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio della provincia dal codice
 */
export const useGetGeolocalizzazioneProvinceCodice = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneProvinceCodice>>,
  TError = ErrorType<unknown>,
>(
  codice: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneProvinceCodice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeolocalizzazioneProvinceCodiceQueryOptions(
    codice,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene l'elenco dei comuni e delle province
 * @summary Elenco dei comuni
 */
export const getGeolocalizzazioneComuni = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ComuniResponse>(
    {
      url: `/framework-cfg-domande/geolocalizzazione/comuni`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneComuniQueryKey = () =>
  [`/framework-cfg-domande/geolocalizzazione/comuni`] as const;

export const getGetGeolocalizzazioneComuniQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeolocalizzazioneComuniQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>
  > = ({ signal }) => getGeolocalizzazioneComuni(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetGeolocalizzazioneComuniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>
>;
export type GetGeolocalizzazioneComuniQueryError = ErrorType<unknown>;

/**
 * @summary Elenco dei comuni
 */
export const useGetGeolocalizzazioneComuni = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeolocalizzazioneComuniQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene il comune ricercato tramite codice
 * @summary Dettaglio del comune dal codice
 */
export const getGeolocalizzazioneComuniCodice = (
  codice: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Comune>(
    {
      url: `/framework-cfg-domande/geolocalizzazione/comuni/${codice}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneComuniCodiceQueryKey = (codice: string) =>
  [`/framework-cfg-domande/geolocalizzazione/comuni/${codice}`] as const;

export const getGetGeolocalizzazioneComuniCodiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
  TError = ErrorType<unknown>,
>(
  codice: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetGeolocalizzazioneComuniCodiceQueryKey(codice);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>
  > = ({ signal }) =>
    getGeolocalizzazioneComuniCodice(codice, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!codice, ...queryOptions };
};

export type GetGeolocalizzazioneComuniCodiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>
>;
export type GetGeolocalizzazioneComuniCodiceQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio del comune dal codice
 */
export const useGetGeolocalizzazioneComuniCodice = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
  TError = ErrorType<unknown>,
>(
  codice: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeolocalizzazioneComuniCodiceQueryOptions(
    codice,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
